import { memo } from "react";

export const InfoIcon = memo(() => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99978 0.666504C12.0497 0.666504 15.3328 3.94962 15.3328 7.99954C15.3328 12.0495 12.0497 15.3326 7.99978 15.3326C3.94986 15.3326 0.666748 12.0495 0.666748 7.99954C0.666748 3.94962 3.94986 0.666504 7.99978 0.666504ZM7.16648 7.3329V11.6661H8.83308V7.3329H7.16648ZM7.16648 4.33302V5.99962H8.83308V4.33302H7.16648Z"
      fill="currentColor"
    />
  </svg>
));
